import { useMemo } from 'react'
import { Heading } from '@chakra-ui/react'
import { BorderedGrid } from '@!/components/Grid/BorderedGrid'

import { FooterMenuItem } from './FooterMenuItem'
import { FooterMenuBlankItem } from './FooterMenuBlankItem'
import { ContentContainer } from '@!/components/Container'
import { getDevice } from '@!/Util/device'

export const FooterMenus = () => {
  const device = useMemo(() => getDevice(), [])

  return (
    <ContentContainer my={device === 'pc' ? 3 : 0}>
      <Heading size="sm" py={3} px={4}>
        サイト一覧
      </Heading>
      <BorderedGrid columns={2} showSideBorders={device !== 'sp'}>
        <FooterMenuItem url="/">マンガBANGブックスTOP</FooterMenuItem>
        <FooterMenuItem url="/store/man">少年・青年マンガ</FooterMenuItem>
        <FooterMenuItem url="/store/woman">少女・女性マンガ</FooterMenuItem>
        <FooterMenuItem url="/store/tl">TLマンガ</FooterMenuItem>
        <FooterMenuItem url="/store/bl">BLマンガ</FooterMenuItem>
        <FooterMenuItem url="/store/rankings">デイリー人気ランキング</FooterMenuItem>
        <FooterMenuItem url="/store/features/home_new20250820">注目新刊</FooterMenuItem>
        <FooterMenuItem url="/store/search/free">おすすめ無料作品一覧</FooterMenuItem>
      </BorderedGrid>

      <Heading size="sm" py={3} px={4}>
        サポートメニュー
      </Heading>
      <BorderedGrid columns={2} showSideBorders={device !== 'sp'}>
        <FooterMenuItem url="/announcements">お知らせ</FooterMenuItem>
        <FooterMenuItem url="/static_page/help">ヘルプ</FooterMenuItem>
        <FooterMenuItem url="/guide">初めての方へ</FooterMenuItem>
        <FooterMenuItem url="/event">ポイント還元について</FooterMenuItem>
        <FooterMenuItem url="/user/payment#/monthly_course">月額登録</FooterMenuItem>
        <FooterMenuItem url="/user/monthly_course_unregister">月額解除</FooterMenuItem>
        <FooterMenuItem url="/static_page/terms">利用規約</FooterMenuItem>
        <FooterMenuItem url="/inquiry">お問い合わせ</FooterMenuItem>
        <FooterMenuItem url="/requirements" target="_blank">
          推奨環境
        </FooterMenuItem>
        <FooterMenuBlankItem />
      </BorderedGrid>
    </ContentContainer>
  )
}
